import React from 'react'

import { cn } from '@/shared/lib'

type IconProps = {
  size?: number | string
  color?: string
} & React.SVGProps<SVGSVGElement>

export const FloorPlanIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('custom-icon', className)}
      {...props}
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5" />
      <path d="M9 3v7" />
      <path d="M21 10h-7" />
      <path d="M3 15h9" />
    </svg>
  )
}
